import { SET_CURRENT_BRANCH } from './constants/ActionTypes';

/*
 * Action creator to set the current branch
 *
 */
export const setCurrentBranch = id => ({
    type: SET_CURRENT_BRANCH,
    id: id
});